import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../../../shared/colors";

export const useExpandableDrawerListItemStyles = makeStyles(() => ({
    root: {
        padding: "0"
    },
    listItemText: {
        color: colors.primary.contrastText
    },
    expandIcon: {
        marginLeft: "auto",
        color: colors.primary.contrastText
    },
    collapsableMenu: {
        backgroundColor: "rgba(177, 69, 54, 0.5)"
    },
    navlink: {
        width: "100%",
        display: "inline-flex",
        padding: "16px",
        textDecoration: "none"
    },
    listItemIcon: {
        color: colors.primary.contrastText
    }
}));
